import {createGlobalStyle} from "styled-components";

const HeroSectionStyle = createGlobalStyle`

.heroSection{
        .heroSection-heading{
            font-size: 54px;
            line-height: 65px;
                span{
                    color: #FF9F46;
                }
        }
        .heroSection-content{
            color: #fff;
            padding-top: 30px;
            padding-bottom: 5px
        }
        .heroSection-border{
            width: 35px;
            height: 3px;
            background: #b1b1b1;
            border-radius: 10px;
            margin-top: 30px;
            margin-bottom: 10px;
        }
        .HeroBtn {
              margin: 20px auto;
              border: none;
              padding: 10px 34px;
              position: relative;
            }
            .HeroBtn::before {
              -webkit-transition: all 0.85s cubic-bezier(0.68, -0.55, 0.265, 1.55);
              transition: all 0.85s cubic-bezier(0.68, -0.55, 0.265, 1.55);
              content: '';
              width: 50%;
              height: 100%;
              background: black;
              position: absolute;
              top: 0;
              left: 0;
            }
            .HeroBtn:hover::before {
              background: #fff;
              width: 100%;
            }
            .HeroBtn .text-white {
              color: #fff;
              mix-blend-mode: color-dodge;
            }
            .HeroBtn::before {
                width: 35%;
                background: #ff9f46;
                border-radius: 10px;
            }
            .HeroBtn:hover::before {
              background: #ff9f46;
              width: 100%;
            }
        }
}

@media only screen and (max-width: 992px) {
  .heroSection {
         .heroSection-heading{
            font-size: 30px;
            line-height: 40px;
         }
  }
    .heroButton-section {
         margin-top: 20px;
    }
}
`;

export default HeroSectionStyle;
